import api from '../../config/base';
import {
  CREATE_EVENT_ERROR,
  CREATE_EVENT_SUCCESS,
  DELETE_EVENT_ERROR,
  DELETE_EVENT_SUCCESS,
  FETCH_EVENTS_ERROR,
  FETCH_EVENTS_SUCCESS,
  UPDATE_EVENT_ERROR,
  UPDATE_EVENT_SUCCESS
} from './types';

// Function to determine if an event should be marked as completed
const getUpdatedEvent = (event) => {
  const now = new Date();
  const endDate = new Date(event.dateAndTime.endDateTime);

  if (now > endDate && event.status !== 'completed') {
    return { ...event, status: 'completed' };
  }
  return event;
};

export const getAllEvents = () => async (dispatch) => {
  try {
    const res = await api.get('events');
    const events = res.data;

    // Check and update status for each event
    await Promise.all(
      events.map(async (event) => {
        const updatedEvent = getUpdatedEvent(event);
        if (updatedEvent.status !== event.status) {
          await api.put(`events/${event._id}`, updatedEvent);
        }
      })
    );

    // Fetch the updated list of events
    const updatedRes = await api.get('events');
    dispatch({
      type: FETCH_EVENTS_SUCCESS,
      payload: updatedRes.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_EVENTS_ERROR,
      payload: error.message,
    });
  }
};




export const createEvent = (event) => async (dispatch) => {
  try {
    const res = await api.post('events', event);
    dispatch({
      type: CREATE_EVENT_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_EVENT_ERROR,
      payload: error.message,
    });
  }
};

export const deleteEvent = (_id) => async (dispatch) => {
  try {
    await api.delete(`events/${_id}`);
    dispatch({
      type: DELETE_EVENT_SUCCESS,
      payload: _id,
    });
  } catch (error) {
    dispatch({
      type: DELETE_EVENT_ERROR,
      payload: error.message,
    });
  }
};

export const updateEvent = (_id, event) => async (dispatch) => {
  try {
    const res = await api.put(`events/${_id}`, event);
    dispatch({
      type: UPDATE_EVENT_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_EVENT_ERROR,
      payload: error.message,
    });
  }
};

export const getEvent = (_id) => async (dispatch) => {
  try {
    const res = await api.get(`events/${_id}`);
    console.log(res);
    // Dispatch action if needed to update the store with the fetched event
  } catch (error) {
    // Handle error if needed
  }
};
